import { format, parse } from 'date-fns'
import { parseISO } from 'date-fns'

export default function () {
  const legacyFormat = 'dd-MM-yyyy'
  const displayFormat = 'dd/MM/yyyy'
  const displayWithHoursFormat = `dd/MM/yyyy - HH:mm 'h'`
  const apiFormat = 'yyyy-MM-dd'

  const getDateObject = (
    inputDate: Date | string,
    fallbackFormats: string[] = [legacyFormat, displayFormat],
  ): Date => {
    if (inputDate instanceof Date) return inputDate
    let outputDate = parseISO(inputDate)
    if (!isNaN(outputDate.getTime())) return outputDate
    for (const fmt of fallbackFormats) {
      outputDate = parse(inputDate, fmt, new Date())
      if (!isNaN(outputDate.getTime())) return outputDate
    }
    return new Date(NaN)
  }

  const legacyDate = (inputDate: Date | string): string => {
    const outputDate = getDateObject(inputDate, [legacyFormat])
    return format(outputDate, legacyFormat)
  }

  const displayDate = (inputDate: Date | string): string => {
    const outputDate = getDateObject(inputDate, [legacyFormat])
    return format(outputDate, displayFormat)
  }

  const displayDateWithHours = (inputDate: Date | string): string => {
    const outputDate = getDateObject(inputDate, [displayFormat, legacyFormat])
    return format(outputDate, displayWithHoursFormat)
  }

  const displayDateWithMonthName = (inputDate: Date | string): string => {
    const outputDate = getDateObject(inputDate, [displayFormat, legacyFormat])
    return new Intl.DateTimeFormat('es-ES', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }).format(outputDate)
  }

  const parseLegacyDate = (date: string): Date => {
    return parse(date, legacyFormat, new Date())
  }

  const parseDate = (date: string): Date => {
    return parse(date, displayFormat, new Date())
  }

  const parseApiDate = (date: string): Date => {
    return parse(date, apiFormat, new Date())
  }

  const apiDate = (inputDate: Date | string): string => {
    const outputDate = getDateObject(inputDate, [legacyFormat, displayFormat])
    if (isNaN(outputDate.getTime())) return String(inputDate)
    return format(outputDate, apiFormat)
  }

  return {
    legacyDate,
    displayDate,
    displayDateWithHours,
    parseLegacyDate,
    parseDate,
    parseApiDate,
    apiDate,
    displayDateWithMonthName,
  }
}
